import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ViewEventList from '../ViewEventList/ViewEventListNew';
import * as PreEventsActions from 'actions/PreEventsActions';
import * as UiSportPreActions from 'actions/UiSportPreActions';
import { ModelService } from 'utils/ModelService';
import moment from 'moment';
import 'moment/locale/da';
import RestService from 'utils/RestService';
import ViewToggleListToolbar from '../../components/ViewToolbars/ViewToggleListToolbarNew';
import { browserHistory } from 'react-router';
import { isTerminal, scrollToTop, detectMobile } from 'utils/UiHelper';
import { SPORTS } from 'constants/appConfig';
import SearchFieldSkeleton from 'components/SkeletonUI/SearchFieldSkeleton/SearchFieldSkeleton';
import HorizontalNavigationSkeleton from 'components/SkeletonUI/HorizontalNavigationSkeleton/HorizontalNavigationSkeleton';
import ViewEventListSkeleton from 'components/SkeletonUI/ViewEventListSkeleton/ViewEventListSkeleton';
import ViewSearchBox from '../../components/ViewSearchBox/ViewSearchBoxNew';
import { TabsContainer } from './styled';
import {
    BoxRoundedBorderBottom,
    SectionTitle,
    SectionWrapper,
} from '../../styled';
import isEqual from 'lodash/isEqual';
import ViewListToolbar from '../../components/ViewToolbars/ViewListToolbar';
import {
    checkValidTournaments,
    getFilteredPreEvents,
    searchTeamsByText,
} from './helper';
import { NoEventsMessageBlue } from '../../components/NoEventsMessage';
import HorizontalNavigation from '../../features/HorizontalNavigation/HorizontalNavigation';
import BackButton from '../../components/BackButton/BackButton';
import { onClickBackBtnHandler } from '../../features/HorizontalNavigation/helper';

const SectionPreTabNew = (props) => {
    const [ranges, setRanges] = useState(null);
    const [openRange, setOpenRange] = useState({});
    const [isConfigLoading, setIsConfigLoading] = useState(true);

    const isMobile = detectMobile();

    const getRanges = () => {
        RestService.GetConfig((gc) => {
            const newRanges = [];
            const currentMoment = moment(gc.date + ' ' + gc.time);

            while (newRanges.length <= 12) {
                const tmpM = currentMoment.format('HH');
                const tmp = tmpM + ':00';

                currentMoment.add('1', 'hours');

                newRanges.push({
                    title: tmp + ' - ' + currentMoment.format('HH') + ':00',
                    strKey: tmpM,
                });
            }

            setRanges(
                (prevRanges) =>
                    isEqual(prevRanges, newRanges) ? prevRanges : newRanges
            );
            setIsConfigLoading(false);
        });
    };

    const windowFocusHandler = () => {
        getRanges();
    };

    const fetchPreEvents = () => {
        props.preEventsActions.getTodayEvents();
    };

    const setEventsBySportAndTime = () => {
        if (ranges && props.preEvents.fetched) {
            props.uiSportPreActions.setEventsBySportAndTime(
                props.preEvents.data,
                ranges
            );
        }
    };

    const setRangeStatuses = () => {
        if (
            props.activeSportId &&
            props.preEventsBySportAndTime &&
            !openRange[props.activeSportId]
        ) {
            const limitOfOpenedItems = 3;
            const activeSportId = props.activeSportId;

            setOpenRange((prevOpenRange) => {
                const newOpenRange = { ...prevOpenRange };

                if (!newOpenRange[activeSportId]) {
                    newOpenRange[activeSportId] = {};
                }

                let counter = 0;
                let isNeedOpenFirstRange = true;

                for (let rangeKey in props.preEventsBySportAndTime[
                    activeSportId
                ]) {
                    newOpenRange[activeSportId][rangeKey] =
                        isNeedOpenFirstRange && counter < limitOfOpenedItems;
                    counter++;
                }

                return newOpenRange;
            });
        }
    };

    const { setActiveSportId, search } = props.uiSportPreActions;

    const horizontalNavClickHandler = useCallback(
        (item) => {
            setActiveSportId(item.id);
        },
        [setActiveSportId]
    );

    const onSearchTextHandler = useCallback(
        (searchText) => {
            search(searchText);
        },
        [search]
    );

    const onToggleElement = useCallback(
        (status, id) => {
            let newOpenRange = {
                ...openRange,
            };

            newOpenRange[props.activeSportId][id] = !newOpenRange[
                props.activeSportId
            ][id];

            setOpenRange(newOpenRange);
        },
        [props.activeSportId, openRange]
    );

    const backBtnHandler = useCallback(() => {
        return onClickBackBtnHandler();
    }, []);

    const filteredSports = useMemo(
        () => {
            return props.preEventsBySportAndTime && props.sportTree.fetched
                ? props.sportTree.sportData.filter((item) => {
                      const rangesBySportId =
                          props.preEventsBySportAndTime[item.id] || {};
                      const allPossibleRangesKeys =
                          ranges?.map((r) => r.strKey) || [];

                      const hasAnyValidFilteredEvents = allPossibleRangesKeys.some(
                          (rangeKey) => {
                              const eventsForRange = rangesBySportId[rangeKey];
                              if (eventsForRange && eventsForRange.length > 0) {
                                  const filteredEvents = eventsForRange.filter(
                                      checkValidTournaments
                                  );
                                  return filteredEvents.length > 0;
                              }
                              return false;
                          }
                      );

                      /*BS-355*/
                      return (
                          rangesBySportId &&
                          ![
                              SPORTS.GOLF,
                              SPORTS.CYKLING,
                              SPORTS.MOTOR_SPORT,
                          ].includes(item.id) &&
                          hasAnyValidFilteredEvents
                      );
                  })
                : [];
        },
        [props.preEventsBySportAndTime, props.sportTree.fetched]
    );

    const getView = () => {
        if (!ranges || !props.preEventsBySportAndTime) {
            return null;
        }

        let rangesViews = [];

        if (activeSportId && openRange[activeSportId]) {
            rangesViews = ranges
                .map((range) => {
                    const isRangeOpen =
                        openRange &&
                        openRange[activeSportId] &&
                        openRange[activeSportId][range.strKey] === true
                            ? 'yes'
                            : 'no';

                    const filteredPreEvents = getFilteredPreEvents(
                        props.preEventsBySportAndTime,
                        activeSportId,
                        range.strKey
                    );

                    if (filteredPreEvents.length > 0) {
                        let viewEventList = null;

                        if (!props.searchText) {
                            if (openRange[activeSportId][range.strKey]) {
                                viewEventList = (
                                    <BoxRoundedBorderBottom>
                                        <ViewEventList
                                            events={ModelService.getSportTree(
                                                props.sportTree.sportData,
                                                filteredPreEvents,
                                                'array',
                                                0,
                                                null,
                                                'sportId',
                                                [3]
                                            )}
                                        />
                                    </BoxRoundedBorderBottom>
                                );
                            }

                            return (
                                <div className="event-tab" key={range.strKey}>
                                    <ViewToggleListToolbar
                                        title={range.title}
                                        toggleHandler={onToggleElement}
                                        tournamentId={range.strKey}
                                        opened={isRangeOpen}
                                    />
                                    {viewEventList}
                                </div>
                            );
                        } else {
                            const searchedEvents = filteredPreEvents.filter(
                                (item) =>
                                    searchTeamsByText(item, props.searchText)
                            );

                            if (searchedEvents.length > 0) {
                                if (openRange[activeSportId][range.strKey]) {
                                    viewEventList = (
                                        <BoxRoundedBorderBottom>
                                            <ViewEventList
                                                events={ModelService.getSportTree(
                                                    props.sportTree.sportData,
                                                    searchedEvents,
                                                    'array',
                                                    0,
                                                    null,
                                                    'sportId'
                                                )}
                                            />
                                        </BoxRoundedBorderBottom>
                                    );
                                }

                                return (
                                    <div
                                        key={range.strKey}
                                        className="search-event"
                                    >
                                        <ViewToggleListToolbar
                                            title={range.title}
                                            toggleHandler={onToggleElement}
                                            tournamentId={range.strKey}
                                            opened={isRangeOpen}
                                        />
                                        {viewEventList}
                                    </div>
                                );
                            }
                        }
                    }
                })
                .filter(Boolean);
        }

        if (rangesViews.length > 0) {
            return rangesViews;
        } else if (props.searchText) {
            return (
                <div>
                    <ViewListToolbar
                        title="00:00 - 23:59"
                        withoutArrow={true}
                    />
                    <BoxRoundedBorderBottom>
                        <NoEventsMessageBlue />
                    </BoxRoundedBorderBottom>
                </div>
            );
        } else {
            return null;
        }
    };

    useEffect(() => {
        fetchPreEvents();
        getRanges();
        setEventsBySportAndTime();
        setRangeStatuses();
        window.addEventListener('focus', windowFocusHandler);
        scrollToTop();
        return () => {
            window.removeEventListener('focus', windowFocusHandler);
        };
    }, []);

    useEffect(
        () => {
            if (
                props.preEventsBySportAndTime &&
                Object.keys(props.preEventsBySportAndTime).length > 0 &&
                (props.activeSportId === 0 ||
                    !props.preEventsBySportAndTime[activeSportId])
            ) {
                const sport = Object.keys(props.preEventsBySportAndTime)[0];

                if (sport) {
                    props.uiSportPreActions.setActiveSportId(sport);
                } else {
                    props.uiSportPreActions.setActiveSportId(
                        Object.keys(props.preEventsBySportAndTime)[0]
                    );
                }
            }

            setRangeStatuses();
        },
        [props.activeSportId, props.preEventsBySportAndTime]
    );

    useEffect(
        () => {
            onSearchTextHandler('');
            scrollToTop();
        },
        [props.activeSportId]
    );

    useEffect(
        () => {
            if (props.preEvents?.data || ranges) {
                setEventsBySportAndTime();
            }
        },
        [props.preEvents?.data, ranges]
    );

    let activeSportId = props.activeSportId;
    const isInitialLoading =
        !props.preEvents.fetched || !props.sportTree.fetched || isConfigLoading;

    const horizontalNav =
        filteredSports.length > 0 ? (
            <HorizontalNavigation
                mode="pre"
                items={filteredSports}
                clickHandler={horizontalNavClickHandler}
                selectedId={activeSportId !== '0' ? activeSportId : 'none'}
            />
        ) : null;

    const view = getView();

    return (
        <>
            <BackButton
                eventTitle={'Tilbage'}
                isMobile={isMobile}
                isLeftSideBarOpen={props.isLeftSideBarOpen}
                onClickBackBtn={backBtnHandler}
            />
            <SectionWrapper $isMobile={isMobile}>
                {isTerminal() ? (
                    <ViewSearchBox
                        onSearchTextHandler={onSearchTextHandler}
                        value={props.searchText}
                    />
                ) : !isInitialLoading ? (
                    <ViewSearchBox
                        showBackBtn="true"
                        onSearchTextHandler={onSearchTextHandler}
                        backBtnHandler={backBtnHandler}
                        value={props.searchText}
                    />
                ) : (
                    <SearchFieldSkeleton />
                )}
            </SectionWrapper>
            <SectionWrapper
                $isMobile={isMobile}
                $margin={'0 0 6px'}
                $padding={'0'}
            >
                {isInitialLoading ? (
                    <HorizontalNavigationSkeleton />
                ) : (
                    horizontalNav
                )}
            </SectionWrapper>
            <SectionWrapper $isMobile={isMobile} $margin={'0'}>
                {isInitialLoading ? (
                    <ViewEventListSkeleton
                        keyword={'pre'}
                        margin={isMobile ? '32px 0 0' : '48px 0 0'}
                    />
                ) : (
                    <>
                        <SectionTitle $isMobile={isMobile}>
                            Starter snart
                        </SectionTitle>
                        <TabsContainer>{view}</TabsContainer>
                    </>
                )}
            </SectionWrapper>
        </>
    );
};

function mapStateToProps(state) {
    return {
        preEvents: state.preEvents,
        sportTree: state.sportTree,
        activeSportId: state.uiSportPre.activeSportId,
        preEventsBySportAndTime: state.uiSportPre.preEventsBySportAndTime,
        searchText: state.uiSportPre.searchText,
        isLeftSideBarOpen: state.ui.leftSidebarOpen,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        preEventsActions: bindActionCreators(PreEventsActions, dispatch),
        uiSportPreActions: bindActionCreators(UiSportPreActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SectionPreTabNew);
